export default function safeCommentOrReplyPreamble(bodyAsPlainText: string): string {
  // Since emojis are supported we cannot rely purely on `textContent.length` as it gives the count of UTF-16 units. The
  // unicode-proof way to get string length in codepoints (in characters) is `[...textContent].length` as the iterable
  // protocol split the string to codepoints
  const textContent = [...bodyAsPlainText.replace(/(\n{1,})/g, " ")];
  const halfTweet = [...textContent].slice(0, 70).join("");
  return textContent.length === halfTweet.length ? textContent.join("") : `${halfTweet}...`;
}
